import styled from 'styled-components';
import BaseModal from 'components/Modal';

const BaseUpsellModal = styled(BaseModal)`
  max-width: 570px;
`;

export default BaseUpsellModal;
